import React, { useState, Fragment } from 'react'
import { withTranslation } from 'i18n'

const Pagination = ({ t, itemsPerPage, totalItems, paginate, borderColor }) => {
  const [currentPage, setCurrentPage] = useState(1)
  let pageNumbers = []
  let firstSetOfPages = []
  let middleSetOfPages = []
  let lastSetOfPages = []
  const totalPages = Math.ceil(totalItems / itemsPerPage)

  for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
    pageNumbers.push(i)
  }

  const pagination = (currentValue) => {
    if (currentValue === 'previous' && currentPage !== 1) {
      paginate(currentPage - 1)
      setCurrentPage(currentPage - 1)
    } else if (currentValue === 'next' && currentPage !== totalPages) {
      paginate(currentPage + 1)
      setCurrentPage(currentPage + 1)
    } else if (currentValue !== 'previous' && currentValue !== 'next') {
      paginate(currentValue)
      setCurrentPage(currentValue)
    }
  }

  const renderPagination = () => {
    if (totalPages > 5) {
      if (currentPage < 5) {
        firstSetOfPages = pageNumbers.slice(0, 5)
        lastSetOfPages = [totalPages]
      } else if (currentPage > totalPages - 5) {
        firstSetOfPages = pageNumbers.slice(0, 1)
        lastSetOfPages = pageNumbers.slice(totalPages - 5, totalPages)
      } else {
        firstSetOfPages = pageNumbers.slice(0, 1)
        middleSetOfPages = pageNumbers.slice(currentPage - 2, currentPage + 1)
        lastSetOfPages = [totalPages]
      }
    } else {
      firstSetOfPages = pageNumbers
    }

    return (
      <Fragment>
        {firstSetOfPages.map(number => (
          renderEachItem(number)
        ))}
        {middleSetOfPages.length
          ? <Fragment>
            ...
            {middleSetOfPages.map(number => (
              renderEachItem(number)
            ))}
          </Fragment>
          : null
        }
        {lastSetOfPages.length
          ? <Fragment>
            ...
            {lastSetOfPages.map(number => (
              renderEachItem(number)
            ))}
          </Fragment>
          : null
        }
      </Fragment>
    )
  }

  const renderEachItem = (number) => {
    return (
      <li
        key={number}
        className={number === currentPage ? 'page-item active' : 'page-item'}
        value={number}
        onClick={(e) => pagination(e.target.value)}
      >
        {number}
      </li>
    )
  }

  return (
    <nav>
      <ul className='pagination'>
        <li
          className={currentPage === 1 ? 'page-item disabled' : 'page-item'}
          onClick={() => pagination('previous')}
        >
          {t('common:common.previous')}
        </li>
        {renderPagination()}
        <li
          className={currentPage === totalPages ? 'page-item disabled' : 'page-item'}
          onClick={() => pagination('next')}
        >
          {t('common:common.next')}
        </li>
      </ul>
      <style>{`
        .pagination {
          text-align: center;
          margin: 30px 0 0;
        }

        .page-item {
          display: inline-block;
          cursor: pointer;
          padding: 5px 10px;
          border: 1px solid #ccc;
          border-radius: 5px;
          margin: 0 2px;
        }

        .page-item.active,
        .page-item:hover {
          border-color: ${borderColor};
        }

        .page-item.disabled {
          pointer-events: none;
          opacity: 0.4;
        }
      `}</style>
    </nav>
  )
}

export default withTranslation(['common'])(Pagination)
